/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
import { Loading, Message,MessageBox } from 'element-ui'
import util from './util'
import Router from "vue-router";
import config, { APP_NAME } from './config'
import { UserManager } from "oidc-client";


var loading = undefined;

var mgr = new UserManager(config);
// 超时时间
axios.defaults.timeout = 50000
// http请求拦截器
axios.interceptors.request.use(config => {

  let token = util.getToken();
  if (token.length > 20) {
    config.headers['Authorization'] = token;
  }
  //loading = Loading.service({ fullscreen: true });

  // element ui Loading方法
  return config
}, error => {
  //关闭loading
  //loading.close();
  Message.error({
    message: '加载超时'
  })
  return Promise.reject(error)
})
// http响应拦截器
axios.interceptors.response.use(resp => {// 响应成功关闭loading
  //关闭loading
  //loading.close();
  var result = resp.data || {};
  if (result.success == false) {
    Message.error({
      message: result.message
    })
  }
  return result
}, error => {
  if (loading) {
   // loading.close()
  }
  if (error.response) {
    if (error.response.status == 401) {
      sessionStorage.clear();
      mgr.signinRedirect();
    }
    if(error.response.status==403){
    
      console.log('-------err------')
      console.log(error);
      // Message.error({
      //   message: `${error.response.statusText},您没有${error.config.url}访问权限。`
      // })
      MessageBox.alert(`${error.response.statusText},您没有${error.config.url}访问权限。`,APP_NAME,{
        type:'error'
      })
    }
  }
  let message = undefined;
  if (error.response) {
    if (error.response.data) {
      message = error.response.data.error_description;
    }
  }
 
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/common/axios.js